$(document).ready(function() {
  $('br').attr('aria-hidden','true');
  $('hr').attr('aria-hidden','true');
  $('#FacetFiltersForm .facets-layout .list-menu__item label > svg').attr('aria-hidden','true');
  

});

// empty Headings
$(document).ready(function() {
  $('h1, h2, h3, h4, h5, h6').filter(function() {
    return $(this).text().replace(/\s+/g, '') === '' && 
           $(this).children().length === 0;
  }).remove();
});
 
// Social and External link warning Fixed
$(document).ready(function() {
  const currentHost = window.location.hostname.replace('www.', '');
  const warningText = " (this link will open in new tab)";

  $('a[href^="http://"], a[href^="https://"]').each(function() {
    const $link = $(this);
    const linkHost = this.hostname.replace('www.', '');

    if (linkHost === currentHost || !linkHost) return; // Skip internal links

    // Get text or fallback from image alt
    let linkText = $link.text().trim();
    if (!linkText) {
      const imgAlt = $link.find('img').attr('alt');
      linkText = imgAlt ? imgAlt.trim() : "this link";
    }

    // Build aria-label
    const currentAriaLabel = $link.attr('aria-label');
    const newLabel = currentAriaLabel 
      ? `${currentAriaLabel}${warningText}` 
      : `${linkText}${warningText}`;

    // Apply attributes
    $link.attr({
      'aria-label': newLabel,
      'title': newLabel, // optional
      'target': '_blank',
      'rel': 'noopener noreferrer nofollow'
    });

    // Add external-link class for styling
    $link.addClass('external-link');
  });
});

// Email Label to all Email Address
$(document).ready(function() {
  // Target ALL email links (any format)
  $('a[href^="mailto:"]').each(function() {
    // Extract email from href
    let email = $(this).attr('href').replace('mailto:', '').trim();
    
    // Clean email (remove query parameters, URL-encoded spaces, etc.)
    email = decodeURIComponent(email) // Handle %20, %40, etc.
            .split('?')[0]           // Remove ?subject=...
            .split('&')[0];           // Remove &body=...
    
    // Set aria-label
    $(this).attr('aria-label', 'Email Address: ' + email);
  });
});

// Phone Label to all Phone Number
$(document).ready(function() {
  $('a[href^="tel:"]').each(function() {
    const $link = $(this);
    const visibleText = $link.text().trim(); // Get what's visually shown
    const existingLabel = $link.attr('aria-label') || '';

    // Only add if not already present
    if (!existingLabel.includes('Phone Number')) {
      const newLabel = `Phone Number: ${visibleText}` + (existingLabel ? `, ${existingLabel}` : '');
      $link.attr('aria-label', newLabel);
    }
  }); 
});  

// blog page heading
$(document).ready(function() {
    // Select the element with class 'card__heading h2' and replace it with an <h2> tag
    $('.card__heading.h2').each(function() {
        var content = $(this).html(); 
        $(this).replaceWith('<h2>' + content + '</h2>'); 
    });
});

// mobile menu focus
// Close drawer when the end close button is clicked
document.querySelectorAll('[data-close-drawer]').forEach(button => {
  button.addEventListener('click', function() {
    const drawer = this.closest('header-drawer');
    const details = drawer.querySelector('details');
    if (details) {
      details.removeAttribute('open');
    }
  });
});

// Trap focus within the drawer when open
document.addEventListener('DOMContentLoaded', function() {
  const drawers = document.querySelectorAll('header-drawer details[open]');
  
  drawers.forEach(details => {
    const drawer = details.querySelector('[role="dialog"]');
    if (drawer) {
      trapFocus(drawer);
    }
  });
});
